import React from 'react';
import { Form } from '@ant-design/compatible';

import { Modal, Input, Button, Select, InputNumber } from 'antd';
import {
    dispensaries as dispensaryServices
} from '../../../services';

const { Option, } = Select;

const PermissionNumberAddForm = Form.create({ name: 'permissionNumberAddForm_into_modal' })(

    class extends React.Component {
        state = {
            serieIdentificatorVS: {},
            companyInfo: {},
            hoses: [],
        };

        componentDidMount() {
            this.getCompanyInfo();
        }

        componentWillReceiveProps(nextProps) {
            this.setState({ hoses: nextProps.unavialableServiceNumbers, });
        }

        getCompanyInfo = () => {
            dispensaryServices.get('company')
                .then(response => {
                    this.setState({ companyInfo: response[0] });
                });
        }

        checkCFDISerial = e => {
            const serie = e.target.value;

            if (serie.length === 2) {
                dispensaryServices.get(`serviceNumber/checkIfServiceNumberFolioExists/${serie}`)
                    .then(response => {
                        if (response === true) {
                            this.setState({
                                serieIdentificatorVS: {
                                    ...this.validateServiceNumberSerie(response, serie),
                                }
                            });
                        } else {
                            this.setState({
                                serieIdentificatorVS: {
                                    ...this.validateServiceNumberSerie(response, serie),
                                }
                            });

                            dispensaryServices.get('serviceNumber/getFolioValues')
                                .then(response => {
                                    const indexOfSerie = response.findIndex(i => i.serie === serie);
                                    console.log('GET', response, indexOfSerie);
                                    if (indexOfSerie === -1) {
                                        this.setState({ initialFolio: 0 });
                                    } else {
                                        this.setState({ initialFolio: response[indexOfSerie].lastFolio });
                                    }
                                });
                        }
                    });
            }
        }

        validateServiceNumberSerie(status, serie) {
            if (status === true) {
                return {
                    validateStatus: 'error',
                    errorMsg: `La serie ${serie} ya existe, por favor seleccione otra.`,
                };
            }

            return {
                validateStatus: 'success',
                errorMsg: null,
            };
        }

        render() {
            const { visible, onCancel, onAdd, form, } = this.props;
            const { getFieldDecorator } = form;
            const { serieIdentificatorVS } = this.state;

            const optionItems = hoses => this.state.hoses.map(hose => (
                <Option key={hose.hoseUUID} value={hose.hoseUUID}>{`Manguera ${hose.responseHoseCode}`}</Option>
            ));

            return (
                <Modal
                    open={visible}
                    title='Agregar Número de Permiso'
                    onCancel={onCancel}
                    onOk={onAdd}
                    footer={[
                        <Button className="back-button" key="back" onClick={onCancel}>Cancelar</Button>,
                        <Button className="submit-button" key="submit" onClick={onAdd}>Agregar</Button>
                    ]}
                >
                    <Form layout='vertical' >
                        <Form.Item style={{ display: 'none' }} label="UUID de la compañía">
                            {getFieldDecorator('idCompanyInfo', {
                                initialValue: this.state.companyInfo.idCompanyInfo,
                                rules: [{ required: true, message: 'Por favor introduce el UUID de la compañía.' }]
                            })(
                                <Input disabled />
                            )}
                        </Form.Item>
                        <Form.Item label="Número de permiso">
                            {getFieldDecorator('numberPermission', {
                                initialValue: this.state.companyInfo.senerLicense,
                                rules: [{ required: true, message: 'Por favor introduce el número de permiso.' }]
                            })(
                                <Input disabled />
                            )}
                        </Form.Item>
                        <Form.Item
                            label="Serie de facturación"
                            extra="Introduce un valor a 2 caracteres, puedes usar sólo números (01), sólo letras (AB) o una combinación (1A)"
                            validateStatus={serieIdentificatorVS.validateStatus}
                            help={serieIdentificatorVS.errorMsg}
                        >
                            {getFieldDecorator('CFDISerial', {
                                rules: [{
                                    required: true, message: 'Por favor introduce la serie de facturación.'
                                }, {
                                    min: 2, message: 'Introduce un valor a 2 caracteres.'
                                }]
                            })(
                                <Input
                                    maxLength={2}
                                    className="common-input"
                                    placeholder="Introduce la serie de facturación"
                                    onChange={value => this.checkCFDISerial(value)}
                                />
                            )}
                        </Form.Item>
                        <Form.Item
                            label="Folio de facturación"
                            extra={`Introduce un folio con un máximo de 4 caracteres, puedes elegir folios a partir del número ${this.state.initialFolio}`}
                        >
                            {getFieldDecorator('CFDIFolio', {
                                rules: [{
                                    required: true, message: 'Por favor introduce el folio de facturación.'
                                }, {
                                    type: 'integer',
                                    asyncValidator: (rule, value) => new Promise((resolve, reject) => {
                                        if (value <= this.state.initialFolio) {
                                            reject(new Error(`Por favor introduce un folio válido, no se pueden utilizar folios menores a ${this.state.initialFolio + 1}`)); // reject with error message
                                        } else if (this.props.form.getFieldValue('CFDISerial') === undefined || this.props.form.getFieldValue('CFDISerial').length < 2) {
                                            reject(new Error('Es necesario capturar primero la serie de facturación'));
                                        } else {
                                            resolve();
                                        }
                                    })
                                }]
                            })(
                                <InputNumber
                                    className="common-input"
                                    maxLength={4}
                                    style={{ width: '100%' }}
                                    placeholder="Introduce folio de facturación"
                                />
                            )}
                        </Form.Item>
                        <Form.Item
                            label="Seleccionar mangueras a asociar"
                        >
                            {getFieldDecorator('hose', {
                                rules: [{ required: true, message: 'Por favor selecciona al menos una manguera.' }],
                            })(
                                <Select
                                    mode="multiple"
                                    placeholder="Selecciona una o más mangueras"
                                >
                                    {optionItems(this.state.hoses)}
                                </Select>
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
            );
        }
    }
);

export default PermissionNumberAddForm;
